import { render, staticRenderFns } from "./RelatorioStatus.vue?vue&type=template&id=891c5f24&scoped=true"
import script from "./RelatorioStatus.vue?vue&type=script&lang=ts"
export * from "./RelatorioStatus.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioStatus.vue?vue&type=style&index=0&id=891c5f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891c5f24",
  null
  
)

export default component.exports